Ext.define('SA.BarChartXAxis', {
    singleton: true,

    render(axis, cfg, scale, lineWidth, yAxisHeight, tickClickHandler) {
        var me = this;

        axis.attr('transform', `translate(0 ${yAxisHeight})`)
            .call(renderAxisLine)
            .selectAll('g')
            .data(scale.domain())
            .enter().append('g')
                .attr('transform', key => `translate(${scale(key) + scale.bandwidth() / 2})`)
                .classed('x-axis-tick', true)
                .call(renderTickLabels);

        axis.selectAll('.x-axis-tick').on('click', tickClickHandler);

        function renderAxisLine(axis) {
            axis.append('line')
                .attr('x1', 0.5).attr('y1', 0.5)
                .attr('x2', lineWidth).attr('y2', 0.5)
                .attr('stroke', cfg.outerGridLineColor);
        }

        function renderTickLabels(ticks) {
            ticks.each((key, i, els) => me.renderLabel(key, els[i], cfg));
        }
    },

    renderLabel(key, tick, cfg) {
        var createSvgEl = el => document.createElementNS('http://www.w3.org/2000/svg', el),
            appendTo = (el, svgEl) => el.appendChild(createSvgEl(svgEl)),
            {name, type, locationAlias: alias} = SA.data.LocationsCache.get(key),
            needsIcon = type === 'combination' || type === 'radius',
            label = alias ? `${alias} [${name}]` : name,
            iconSize = 15, iconRightMargin = 8,
            iconWidthPlusRightMargin = iconSize + iconRightMargin,
            textGroup = createTextGroup();

        addText();
        maybeAddIcon();
        translateAndRotate();

        function createTextGroup() {
            return d3.select(appendTo(tick, 'g'))
                .attr('fill', cfg.xAxisFontColor)
                .attr('text-anchor', 'start')
                .style('font-family', cfg.fontFamily)
                .style('font-size', cfg.xAxisFontSize)
                .style('font-variant', cfg.fontVariant)
                .style('letter-spacing', '0.2px')
                .node();
        }

        function maybeAddIcon() {
            if (!needsIcon) {
                return;
            }

            var y = (textGroup.getBBox().height / 2) - 19, 
                symbol = document.querySelector(`#sa-icon-${type}-location`);

            d3.select(textGroup)
                .append('svg')
                .attr('viewBox', symbol.getAttribute('viewBox'))
                .attr('x', -iconWidthPlusRightMargin)
                .attr('y', y)
                .attr('width', iconSize)
                .attr('height', iconSize)
                .append(() => symbol.firstElementChild.cloneNode(true))
                    .attr('opacity', 0.4);
        }

        function translateAndRotate() {
            var getLegLength = hypoteneuseLength => Math.sqrt((Math.pow(hypoteneuseLength, 2) / 2)),
                lowestTop, lowestTopLineIndex, lowestTopLineWidth, xOffset, yOffset, legLength;

            textGroup.setAttribute('transform', 'rotate(-45 0 0)');

            Array.from(textGroup.querySelectorAll('text')).forEach((el, i) => {
                let top = el.getBoundingClientRect().top;

                if (typeof lowestTop === 'undefined' || top < lowestTop) {
                    lowestTop = top;
                    lowestTopLineIndex = i;
                    lowestTopLineWidth = el.getBBox().width;
                }
            });

            legLength = getLegLength(lowestTopLineWidth);

            xOffset = 12 - legLength - getLegLength(textGroup.getBBox().height / 2);
            yOffset = 12 + legLength - getLegLength(cfg.xAxisLabelLineHeight * lowestTopLineIndex);

            textGroup.setAttribute('transform', `translate(${xOffset} ${yOffset}) rotate(-45 0 0)`);
        }

        function addText() {
            var spansByLine = getSpansByLine();

            spansByLine.forEach((spans, i) => {
                let textEl = appendTo(textGroup, 'text');

                textEl.setAttribute('y', i * cfg.xAxisLabelLineHeight);

                spans.forEach(span => {
                    let tspan = appendTo(textEl, 'tspan');

                    if (span.spanType === 'aliasName') {
                        tspan.setAttribute('font-style', 'italic');
                    }
                    else if (span.spanType === 'aliasedName') {
                        tspan.setAttribute('fill', cfg.aliasedLocationFontColor);
                    }

                    tspan.textContent = span.text.replace(/\s+$/, '\u00a0');
                });
            });

            function getSpansByLine() {
                if (!alias) {
                    return getCharsByLine().map(chars => [{text: chars.join('')}]);
                }

                return getSpansByLineForAliasedLocation();

                function getSpansByLineForAliasedLocation() {
                    var spanType = 'aliasName',
                        getNewSpan = () => ({spanType, text: ''}),
                        index = 0,
                        aliasedNameIndex = SA.String.getCodePointLength(alias) + 1;

                    return getCharsByLine().map(chars => {
                        let spans = [getNewSpan()];

                        chars.forEach(char => {
                            if (index === aliasedNameIndex) {
                                spanType = 'aliasedName';
                                spans.push(getNewSpan());
                            }

                            spans[spans.length - 1].text += char;

                            index++;
                        });

                        return spans;
                    });
                }

                function getCharsByLine() {
                    var TextWrap = SA.view.util.TextWrap,
                        fontSize = cfg.xAxisFontSize,
                        maxWidth = cfg.xAxisLabelMaxWidth,
                        maxWidth = needsIcon ? (maxWidth - iconWidthPlusRightMargin) : maxWidth;

                    return TextWrap.getCharsByLine(label, fontSize, maxWidth);
                }
            }
        }
    }
});